import React from 'react';
import { CheckCircle, Lightbulb } from '../../../../shared/assets/AppIcons';
import { Button } from '@/shared/ui/button';
import {
  PageActionRow,
  PrimaryActionButton,
} from '../../../../shared/components/patterns';

export default function AutomationsTabs({
  activeTab,
  activeCount,
  suggestedCount,
  onTabChange,
  onRequestCustom,
}) {
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex gap-2">
        <Button
          variant={activeTab === 'attive' ? 'default' : 'outline'}
          onClick={() => onTabChange('attive')}
          className={activeTab === 'attive' ? 'bg-[var(--success)] hover:bg-[var(--success)]' : ''}
        >
          <CheckCircle size={16} className="mr-2" />
          Automazioni Attive ({activeCount})
        </Button>
        <Button
          variant={activeTab === 'suggerite' ? 'default' : 'outline'}
          onClick={() => onTabChange('suggerite')}
          className={activeTab === 'suggerite' ? 'bg-[var(--warning)] hover:bg-[var(--warning)]' : ''}
        >
          <Lightbulb size={16} className="mr-2" />
          Suggerite per Te ({suggestedCount})
        </Button>
      </div>
      <PageActionRow label="Azioni automazioni">
        <PrimaryActionButton onClick={onRequestCustom} aria-label="Richiedi Automazione">
          Richiedi Automazione
        </PrimaryActionButton>
      </PageActionRow>
    </div>
  );
}
